import { create } from "zustand";

type EnterpriseStoreState = {
  closeAskReli: () => void;
  isMaturityHelpOpen: boolean;
  isAskReliOpen: boolean;
  openAskReli: () => void;
  setMaturityHelpOpen: (open: boolean) => void;
  externalCustomerId: string | null;
  setExternalCustomerId: (id: string | null) => void;
};

export const useEnterpriseStore = create<EnterpriseStoreState>((set) => ({
  closeAskReli: () => set({ isAskReliOpen: false }),
  isAskReliOpen: false,
  isMaturityHelpOpen: false,
  openAskReli: () => set({ isAskReliOpen: true }),
  setMaturityHelpOpen: (open) => set({ isMaturityHelpOpen: open }),
  externalCustomerId: null,
  setExternalCustomerId: (id) => set({ externalCustomerId: id }),
}));
